"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var DOMPurify = _interopRequireWildcard(require("dompurify"));

require("../input/InputComponent.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TextArea = _antd.Input.TextArea;

var TextAreaComponent = function TextAreaComponent(_ref) {
  var rows = _ref.rows,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "100%" : _ref$width,
      placeholder = _ref.placeholder,
      value = _ref.value,
      name = _ref.name,
      onChange = _ref.onChange,
      maxLength = _ref.maxLength,
      defaultValue = _ref.defaultValue,
      className = _ref.className,
      disabled = _ref.disabled;
  return /*#__PURE__*/_react["default"].createElement(TextArea, {
    rows: rows || "1",
    placeholder: placeholder,
    value: value && DOMPurify.sanitize(value),
    name: name,
    onChange: onChange,
    defaultValue: defaultValue || "",
    className: "".concat(className, " iiht-ant-input"),
    style: {
      width: width
    },
    maxLength: maxLength,
    disabled: disabled
  });
};

var _default = TextAreaComponent;
exports["default"] = _default;